<template>
    <Card>
		<Row :gutter="16">
			  <Col span="24" label="购物车" name="preSale">
		<div class="global-tool-bar">
		<PreSaleOrderList  v-model="preSale"
					ref="preSaleOrderList" />
		</div>
        </Col>
	</Row>
    </Card>
</template>

<script>
import PreSaleOrderList from '../../preSale-management/preSale-order/preSale-order-list';

export default {
    name: 'sale-list',
    components: {
        PreSaleOrderList
    },
    data() {
        return {
            preSale: 'preSale'
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
